import React, { useState } from 'react'
import { Button, Divider, Stack, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { SideContent } from 'pages/Contacts/List/Card/PreviewStyles'

import { ModalPrint } from './CardStandard'
import { useCouponsSelected } from '../store'
import usePdf from '../use-pdf'
import { trackEvent } from 'analytics'

const Header = () => {
  const [couponsSelected, setCouponsSelected] = useCouponsSelected()
  const theme = useTheme()
  const { t } = useTranslation()

  const handleClose = () => {
    setCouponsSelected([])
  }

  return (
    <Stack direction={'row'} justifyContent={'space-between'}>
      <Stack direction={'row'} gap={1}>
        <Stack
          sx={{
            width: 32,
            height: 32,
            borderRadius: 16,
            backgroundColor: '#DBE8FE',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          <i className={'fa-solid fa-list-check'} style={{ color: theme.palette.primary.main }} />
        </Stack>
        <Stack>
          <Typography component={'span'} sx={{ fontSize: 10 }}>
            {t('coupons.card_in_mass.count', { count: couponsSelected.length })}
          </Typography>
          <Typography component={'span'} sx={{ fontSize: 14, fontWeight: 600 }}>
            {t('coupons.card_in_mass.title')}
          </Typography>
        </Stack>
      </Stack>
      <i
        className={'fa-light fa-xmark'}
        style={{ cursor: 'pointer' }}
        onClick={handleClose}
      />
    </Stack>
  )
}

const CardInMass = () => {
  const [couponsSelected, setCouponsSelected] = useCouponsSelected()
  const [showModal, setShowModal] = useState<boolean>(false)
  const { t } = useTranslation()
  const theme = useTheme()
  const { handlePrintSelection } = usePdf()

  return (
    <>
      {showModal && (
        <ModalPrint
          onClose={() => setShowModal(false)}
          onClick={async withOffer => {
            await handlePrintSelection({ withOffer })
            trackEvent('print_code', {
              action_scope: 'bulk',
              item_count: couponsSelected.length,
            })
            setShowModal(false)
          }}
        />
      )}
      <SideContent width={'320px'}>
        <Stack gap={2} flex={1}>
          <Header />
          <Stack justifyContent={'space-between'} flex={1}>
            <Stack
              gap={2}
              sx={{
                overflowY: 'scroll',
                height: 'calc(100cqh - 336px)',
                pr: 2,
                mr: -1,
                scrollbarWidth: 'none',
                px: 1,
                py: 1
              }}
            >
              <Stack gap={1}>
                {
                  couponsSelected.map(coupon => (
                    <Stack direction={'row'} justifyContent={'space-between'}>
                      <Typography component={'span'} sx={{ color: 'content.secondary', fontSize: 12 }}>
                        {coupon.code}
                      </Typography>
                      <Stack
                        sx={{
                          width: 16,
                          height: 16,
                          backgroundColor: theme.palette.grey[200],
                          borderRadius: 10
                        }}
                        justifyContent={'center'}
                        alignItems={'center'}>
                        <i
                          className={'fa-solid fa-minus'}
                          style={{ cursor: 'pointer', fontSize: 12 }}
                          onClick={() => {
                            setCouponsSelected(prev => prev.filter(({ id }) => id !== coupon.id))
                          }}
                        />
                      </Stack>
                    </Stack>
                  ))
                }
              </Stack>
            </Stack>
            <Stack gap={2} pb={2}>
              <Divider sx={{ borderColor: '#F7F7F7' }} />
              <Stack direction={'row'} justifyContent={'space-between'}>
                <Button
                  size={'small'}
                  variant={'outlined'}
                  onClick={() => {
                    setCouponsSelected([])
                  }}
                >
                  {t('ui_elements.cancel')}
                </Button>
                <Button
                  size={'small'}
                  color={'primary'}
                  variant={'contained'}
                  onClick={async () => {
                    const hasOffer = couponsSelected.some(({ offer }) => Boolean(offer))
                    if (hasOffer) {
                      setShowModal(true)
                    } else {
                      await handlePrintSelection({ withOffer: false })
                      trackEvent('print_code', {
                        action_scope: 'bulk',
                        item_count: couponsSelected.length,
                      })
                    }
                  }}
                >
                  {t('ui_elements.print')}
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </SideContent>
    </>
  )
}

export default CardInMass